import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type RulerPencilIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const RulerPencilIllustration = ({ ...props }: RulerPencilIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeLinecap="square" fill="none">
      <line x1="50" x2="50" y1="12" y2="48" />
      <line x1="40" x2="60" y1="12" y2="12" />
      <line strokeLinecap="butt" x1="40" x2="60" y1="48" y2="48" />
      <polygon points="60,48 50,60 40,48 40,2 60,2 " />
      <line strokeLinecap="butt" x1="4" x2="13" y1="30" y2="30" />
      <line strokeLinecap="butt" x1="4" x2="11" y1="38" y2="38" />
      <line strokeLinecap="butt" x1="4" x2="11" y1="54" y2="54" />
      <line strokeLinecap="butt" x1="4" x2="13" y1="14" y2="14" />
      <line strokeLinecap="butt" x1="4" x2="11" y1="22" y2="22" />
      <line strokeLinecap="butt" x1="4" x2="13" y1="46" y2="46" />
      <circle cx="20" cy="10" r="2" />
      <rect height="60" width="24" x="4" y="2" />
    </g>
  </BaseIllustration>
);

RulerPencilIllustration.displayName = 'RulerPencilIllustration';
